// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".wrapper--1hTsdpKP {\n  display: flex;\n  gap: 6px;\n}\n  .wrapper--1hTsdpKP .name--achlmRl5 {\n    flex: 5;\n  }\n  .wrapper--1hTsdpKP .version--1dGpFJZq {\n    flex: 1;\n  }\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": "wrapper--1hTsdpKP",
	"name": "name--achlmRl5",
	"version": "version--1dGpFJZq"
};
export default ___CSS_LOADER_EXPORT___;
